
import {finalize} from 'rxjs/operators';
import { assign } from 'lodash';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Record } from './record';
import { RecordService, RecordFilter } from './record.service';
import { RecordFilterDialogComponent } from './record-filter-dialog.component';
import { NotifierService, DialogService } from '../ui';

const FILTER_KEY = 'records.filter';

@Component({
  templateUrl: './record-list.component.html',
})
export class RecordListComponent implements OnInit {

  filter: RecordFilter;

  perPage = 10
  recordsCount: number = 0
  records: Record[]

  constructor(
    private recordService: RecordService,
    private router: Router,
    private notifier: NotifierService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    this.filter = new RecordFilter();

    // Load filter from localStorage
    if(window.localStorage) {
      try {
        let data = window.localStorage.getItem(FILTER_KEY);

        let filterData = JSON.parse(data);

        assign(this.filter, filterData);
      }
      catch(err) {
      }
    }
    
    this.fetch();
  }

  fetchMore() {
    this.fetch(this.records.length);
  }

  private fetch(offset = 0, limit = this.perPage, replace = false) {
    this.notifier.startProgress();

    this.filter.offset = offset;
    this.filter.limit = limit;

    this.recordService
      .records(this.filter).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        // Replace
        if (replace) {
          this.records = result.records;
        }
        // Append
        else {
          this.records = [...this.records || [], ...result.records];
        }

        this.recordsCount = result.recordsCount;
      });
    
    // Save filter to localStorage
    if(window.localStorage) {
      window.localStorage.setItem(FILTER_KEY, JSON.stringify(this.filter));
    }
  }

  showRecord(record: Record, event: Event) {
    let nodeName = (<Element>event.target).nodeName;

    if (nodeName === 'TD' || nodeName === 'TR') {
      this.router.navigate(['records', record.id]);
    }
  }

  applyFilter() {
    this.dialogService.show({
      component: RecordFilterDialogComponent,
      props: {

        filter: this.filter,

        onClose: () => {
          this.dialogService.hide();
        },

        onApply: (filter: RecordFilter) => {
          this.fetch(0, this.perPage, true);
        }
      }
    });
  }

  clearSearch() {
    this.filter.search = '';

    this.fetch(0, this.perPage, true);
  }
}
